import logo from "../resources/Alatrivia_logo-transparent.png";
import { useState, useEffect, useRef } from "react";
import { Menu, Settings, BarChart3 } from "lucide-react";

export default function WelcomeModeScreen({
  onSelectMode,
  errorMessage,
  onOpenStats,
  onOpenSettings,
  canStartStudy,
  title = "Train Your Trivia Skills",
  subtitle = "Choose your training mode",
}) {

  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    if (!menuOpen) return;

    function handleClickOutside(event) {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target)
      ) {
        setMenuOpen(false);
      }
    }

    document.addEventListener("pointerdown", handleClickOutside);

    return () => {
      document.removeEventListener(
        "pointerdown",
        handleClickOutside
      );
    };
  }, [menuOpen]);

  function unlockSpeech() {
    const utterance = new SpeechSynthesisUtterance("");
    window.speechSynthesis.speak(utterance);
  }

  return (
    <div className="welcome-screen">
      <div className="welcome-menu" ref={menuRef}>
        <button
          type="button"
          className="welcome-menu__button"
          onClick={() => setMenuOpen((open) => !open)}
          aria-label="Open menu"
          aria-expanded={menuOpen}
        >
          <Menu size={26} />
        </button>

        {menuOpen && (
          <div className="welcome-menu__dropdown">
            <button
              type="button"
              className="welcome-menu__item"
              onClick={() => {
                setMenuOpen(false);
                onOpenStats();
              }}
            >
              <BarChart3 size={20} />
              <span>Stats</span>
            </button>

            <button
              type="button"
              className="welcome-menu__item"
              onClick={() => {
                setMenuOpen(false);
                onOpenSettings();
              }}
            >
              <Settings size={20} strokeWidth={2.25} />
              <span>Settings</span>
            </button>
          </div>
        )}
      </div>


      <div className="welcome-screen__content">
        <header className="welcome-screen__header">
          <img
            src={logo}
            alt="Alatrivia logo"
            className="home-logo"
            width="120"
            height="120"
            loading="eager"
            fetchpriority="high"
          />
          <p className="brand-name">Alatrivia</p>
          <h1 className="welcome-screen__title">{title}</h1>
          <p className="welcome-screen__subtitle">{subtitle}</p>
        </header>

        {errorMessage && (
          <div className="api-error-message">
            <div className="api-error-icon">!</div>
            <h2>{errorMessage.title}</h2>
            <p>{errorMessage.body}</p>
          </div>
        )}

        <div className="welcome-screen__modes">
          <button
            type="button"
            className="mode-card mode-card--buzzer"
            onClick={() => {
              unlockSpeech();
              onSelectMode?.("decision");
            }}
          >
            <div className="mode-card__badge">Fast-paced</div>
            <div className="mode-card__title">Buzzer Mode</div>
            <div className="mode-card__description">
              Practice timing, pressure, and fast decisions with the buzzer.
            </div>
          </button>

          <button
            type="button"
            className={`mode-card mode-card--study ${!canStartStudy ? "mode-card--disabled" : ""
              }`}
            onClick={() => onSelectMode?.("review")}
          >
            <div className="mode-card__badge">Focused</div>
            <div className="mode-card__title">Study Mode</div>
            <div className="mode-card__description">
              Review clues at your own pace and build accuracy.
            </div>

            {!canStartStudy && (
              <div className="mode-card__warning">
                Select at least one category in Settings.
              </div>
            )}
          </button>

          {/* <button
            type="button"
            className="mode-card mode-card--game"
            onClick={() => onSelectMode?.("full_game")}
          >
            <div className="mode-card__badge">Classic</div>
            <div className="mode-card__title">Full Game</div>
            <div className="mode-card__description">
              Play a full board with categories, clues, and scoring.
            </div>
            <ul className="mode-card__features">
              <li>Choose your clues</li>
              <li>Build your score</li>
              <li>Full session experience</li>
            </ul>
          </button> */}

        </div>

        <footer className="app-footer">
          © 2026 Alatrivia. All rights reserved.
        </footer>
      </div>

    </div>
  );
}